import api from '@/utils/api';

const controller = 'v1.0/tipoCallback';
const tipoCallbackExport = Object.assign(
    {},
    api.GetCrud(controller, ["none"]),
    {
        CadastroTipoCallback: function (model) {
            return api.Axios.Post(controller, model);
        },
        AtualizarTipoCallback: function (model) {
            return api.Axios.PutWithoutId(controller, model);
        },
        GetById: function (id) {
            return api.Axios.Get(controller + "/" + id);
        },
        GetTodos: function () {
            return api.Axios.Get(controller + "/Todos");
        },
        Delete: function (id) {
            return api.Axios.Delete(controller + "/" + id);
        },
    }
);

export default tipoCallbackExport;